import { call, put, takeEvery } from 'redux-saga/effects';
import { acceptError } from 'common/_redux';
import * as api from '../api';
import { MARKETING_REQUEST } from './actions';

export function* marketingRequest({ operation, args, resolve, reject }) {
  try {
    const response = yield call(api[operation], ...args);
    if (response.status >= 400 && (response.status !== 400 || operation.startsWith('get'))) {
      const error = new Error((response.data && response.data.detail) || 'Marketing request failed');
      error.response = response;
      throw error;
    }
    resolve(response);
  } catch (error) {
    // Field validation stays beside the editor; transport/server errors use the
    // application's shared reporting and error dialog.
    if (error.response && error.response.status === 400 && !operation.startsWith('get')) {
      resolve(error.response);
    } else {
      yield put(acceptError(error, true));
      reject(error);
    }
  }
}

export default function* marketingSaga() {
  yield takeEvery(MARKETING_REQUEST, marketingRequest);
}
